/* eslint-disable import/prefer-default-export */
import React from 'react'
import { SvgIconProps } from './SvgIconProps'

export const StarAi: React.FC<SvgIconProps> = ({ size = '24px', color = 'currentColor' }) => {
  return <svg width={size} height={size} viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M9.06152 2.06155L9.97257 5.70575C10.1503 6.41685 10.2392 6.7724 10.4244 7.06172C10.5881 7.31763 10.8054 7.53496 11.0614 7.69871C11.3507 7.88384 11.7062 7.97273 12.4173 8.15051L16.0615 9.06155L12.4173 9.9726C11.7062 10.1504 11.3507 10.2393 11.0614 10.4244C10.8054 10.5881 10.5881 10.8055 10.4244 11.0614C10.2392 11.3507 10.1503 11.7063 9.97257 12.4174L9.06152 16.0616L8.15048 12.4174C7.9727 11.7063 7.88381 11.3507 7.69868 11.0614C7.53493 10.8055 7.3176 10.5881 7.06169 10.4244C6.77237 10.2393 6.41682 10.1504 5.70572 9.9726L2.06152 9.06155L5.70572 8.15051C6.41682 7.97273 6.77237 7.88384 7.06169 7.69871C7.3176 7.53496 7.53493 7.31763 7.69868 7.06172C7.88381 6.7724 7.9727 6.41685 8.15048 5.70575L9.06152 2.06155Z"
      fill={color}
      stroke={color}
      strokeMiterlimit="16"
      strokeLinecap="round"
    />
  </svg>
}
